import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})

export class HomeComponent {
  router = inject(Router);

  routeToComponent(url: string): void {
    this.router.navigate([url])
  }
}
